import api from './api';

export const getOptionCategories = async () => {
  const { data } = await api.get('/options/categories');
  return data;
};

export const createOptionCategory = async (name) => {
  const { data } = await api.post('/options/categories', { name });
  return data;
};

export const updateOptionCategory = async (id, params) => {
  const { data } = await api.put(`/options/categories/${id}`, params);
  return data;
};

export const deleteOptionCategory = async (id) => {
  const { data } = await api.delete(`/options/categories/${id}`);
  return data;
};

export const createOption = async (params) => {
  const { data } = await api.post('/options', params);
  return data;
};

export const updateOption = async (id, params) => {
  const { data } = await api.put(`/options/${id}`, params);
  return data;
};

export const deleteOption = async (id) => {
  const { data } = await api.delete(`/options/${id}`);
  return data;
};
